<template>
    <div>
        <h2 class="tb open" v-if="!inline"> Exec Command <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none"> <path d="M9 6L15 12L9 18" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg> </h2>

        <div class="tbgrid open" :class="{inline: inline}">
            <div v-ripple class="tool" @click="toolbox('heroic')"> Heroic </div>
            <div v-ripple class="tool" @click="toolbox('steam')"> Steam </div>

            <div v-ripple class="tool" @click="toolbox('startsunshine')"> Start VDS </div>
            <div v-ripple class="tool" @click="toolbox('stopsunshine')"> Stop VDS </div>

            <div v-ripple class="tool" @click="toolbox('oversteer')"> Config Oversteer </div>

            <div v-ripple class="tool" @click="toolbox('vdON')"> Virtual Display On </div>
            <div v-ripple class="tool" @click="toolbox('vdOFF')"> Virtual Display Off</div>

            <div v-ripple class="tool" @click="toolbox('move')"> Move Windows to VD </div>
            <div v-ripple class="tool" @click="toolbox('restart')"> Reload Game </div>
            <div v-ripple class="tool" @click="toolbox('hide')"> Hide WR </div>
            <div v-ripple class="tool" @click="toolbox('show')"> Show WR </div>
        </div>
    </div>
</template>

  <script>
  export default {
    name: 'GamesToolbox',

    components: { },
    props: {
          inline: Boolean
   },

    watch: {
    },

    data: function(){
      return { }
    },

    methods: {
      toolbox(action){
          window.afetch(`/toolbox?action=${action}`)
      },
    },

    computed: {
    },

    mounted: async function(){
    }
  }

  </script>

  <style lang="scss">
.tbgrid{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height: 0px;
    opacity: 0;
    transition-duration: 0.3s;
    &.open{
        height: auto;
        opacity: 1;
        transition-duration: 0.3s;
    }
    > div{
        border: 1px solid white;
        padding: 2px 1px;
        text-transform: uppercase;
        width: 30%;
        font-size: 9px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 25px;
        color: white;
        margin-left: 2%;
        margin-bottom: 2%;
        text-align: center;
    }

    &.inline{
        justify-content: space-between;
        > div{
            width: calc(50% - 30px);
            padding: 10px;
        }
    }
}
</style>


